import React from "react";
import { Modal, Form as FormLayout } from "react-bootstrap";
import SVG from "react-inlinesvg";
import { Formik, Form } from "formik";
import cogoToast from "cogo-toast";
import { useUpdateCampaignMutation } from "../../../../../redux/apiSlice";
import SelectInput from "../../../Common/components/select-input";
import TextInput from "../../../Common/components/text-input";
import DateInput from "../../../Common/components/date-input";
import { format } from "date-fns";
import Select from "react-select";
import { toAbsoluteUrl } from "../../../../../_metronic/_helpers";

const EditCampaignModal = ({ showEditCampaignModal, onHide, details, tableRef }) => {
    const [updateCampaign, { isLoading: isUpdating }] = useUpdateCampaignMutation();

    const onSubmit = (values) => {
        const payload = {
            ...values,
            startDate: values.startDate ? format(new Date(values.startDate), "yyyy-MM-dd HH:mm:ss") : null,
            endDate: values.endDate ? format(new Date(values.endDate), "yyyy-MM-dd HH:mm:ss") : null,
        };

        updateCampaign({
            id: details?.campaignId,
            ...payload,
        })
            .unwrap()
            .then(() => {
                tableRef?.current?.refresh();
                cogoToast.success("Campaign update action successfull");
                onHide();
            })
    };

    const initialValues = {
        name: details?.name || "",
        type: details?.type || "",
        timeline: details?.timeline || "",
        description: details?.description || "",
        colorCode: details?.colorCode || "",
        durationType: details?.durationType || "",
        target: details?.target || 0,
        recurrentDays: details?.recurrentDays || [],
        rewardAmount: details?.rewardAmount || 0,
        rewardCurrency: details?.rewardCurrency || "GEMS",
        startDate: details?.startDate ? format(new Date(details.startDate), "yyyy-MM-dd") : "",
        endDate: details?.endDate ? format(new Date(details.endDate), "yyyy-MM-dd") : "",
    };

    return (
        <Modal
            show={showEditCampaignModal}
            onHide={onHide}
            aria-labelledby="contained-modal-title-vcenter"
            backdrop={isUpdating ? "static" : true}
            keyboard={!isUpdating}
        >
            <Formik
                initialValues={initialValues}
                onSubmit={onSubmit}
            >
                {({ handleChange, values, setFieldValue }) => (
                    <Form noValidate>
                        <Modal.Header>
                            <Modal.Title id="contained-modal-title-vcenter">
                                <span className="svg-icon svg-icon-lg svg-icon-primary mr-3">
                                    <SVG
                                        title=""
                                        src={toAbsoluteUrl("/media/svg/icons/Shopping/Safe.svg")}
                                    />
                                </span>
                                Edit Campaign
                            </Modal.Title>
                            <button type="button" className="close" onClick={onHide}>
                                <span aria-hidden="true" className="d-block">×</span>
                                <span className="sr-only">Close</span>
                            </button>
                        </Modal.Header>
                        <Modal.Body className="px-10 py-2">
                            <FormLayout.Row className="d-flex flex-wrap">
                                <div className="w-50 p-2">
                                    <TextInput
                                        label="Name"
                                        name="name"
                                        value={values.name}
                                        onChange={handleChange}
                                    />
                                </div>
                                <div className="w-50 p-2">
                                    <TextInput
                                        label="Description"
                                        name="description"
                                        value={values.description}
                                        onChange={handleChange}
                                    />
                                </div>
                            </FormLayout.Row>
                            <FormLayout.Row className="d-flex flex-wrap">
                                <div className="w-50 p-2">
                                    <SelectInput
                                        label="Duration Type"
                                        name="durationType"
                                        options={["FIXED", "FLASH"]}
                                        value={values.durationType}
                                        onChange={(event) => {
                                            handleChange(event);
                                            if (event.target.value === "FLASH") {
                                                setFieldValue("timeline", "DAILY");
                                            }
                                        }}
                                    />
                                </div>
                                <div className="w-50 p-2">
                                    <SelectInput
                                        label="Type"
                                        name="type"
                                        options={["ORDER", "REFERRAL"]}
                                        value={values.type} 
                                        onChange={handleChange}
                                    />
                                </div>
                            </FormLayout.Row>
                            <FormLayout.Row className="d-flex flex-wrap">
                                <div className="w-50 p-2">
                                    <SelectInput
                                        label="Timeline"
                                        name="timeline"
                                        options={["WEEKLY", "MONTHLY", "DAILY"]}
                                        value={values.timeline}
                                        onChange={handleChange}
                                    />
                                </div>
                                <div className="w-50 p-2">
                                    <label htmlFor="colorCode" className="form-label">
                                        Color Code
                                    </label>
                                    <div className="d-flex align-items-center">
                                        <input
                                            type="color"
                                            id="colorPicker"
                                            value={values.colorCode}
                                            onChange={(e) => setFieldValue("colorCode", e.target.value)}
                                            style={{ width: "50px", height: "36px", border: "none", marginRight: "10px", cursor: "pointer" }}
                                        />
                                        <input
                                            type="text"
                                            name="colorCode"
                                            className="form-control"
                                            placeholder="#f8uy64"
                                            value={values.colorCode}
                                            onChange={(e) => setFieldValue("colorCode", e.target.value)}
                                            maxLength={7}
                                        />
                                    </div>
                                </div>
                            </FormLayout.Row>
                            {values.durationType === "FLASH" && (
                                <FormLayout.Row className="d-flex flex-wrap" style={{ paddingTop: "20px" }}>
                                    <div className="w-100 p-2">
                                        <label htmlFor="recurrentDays" className="form-label">
                                            Recurring Days
                                        </label>
                                        <Select
                                            id="recurrentDays"
                                            isMulti
                                            isClearable
                                            options={[
                                                { label: "Monday", value: 1 },
                                                { label: "Tuesday", value: 2 },
                                                { label: "Wednesday", value: 3 },
                                                { label: "Thursday", value: 4 },
                                                { label: "Friday", value: 5 },
                                                { label: "Saturday", value: 6 },
                                                { label: "Sunday", value: 7 },
                                            ]}
                                            onChange={(selectedOptions) => {
                                                const selectedValues = selectedOptions ? selectedOptions.map((option) => option.value) : [];
                                                setFieldValue("recurrentDays", selectedValues);
                                            }}
                                            value={values.recurrentDays.map((day) => ({
                                                label: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"][day - 1],
                                                value: day,
                                            }))}
                                            className="w-100"
                                        />
                                    </div>
                                </FormLayout.Row>
                            )}
                            <FormLayout.Row className="d-flex flex-wrap">
                                <div className="w-50 p-2">
                                    <TextInput
                                        label="Target"
                                        name="target"
                                        type="number"
                                        value={values.target}
                                        onChange={handleChange}
                                    />
                                </div>
                                <div className="w-50 p-2">
                                    <TextInput
                                        label="Reward Amount"
                                        name="rewardAmount"
                                        type="number"
                                        value={values.rewardAmount}
                                        onChange={handleChange}
                                    />
                                </div>
                            </FormLayout.Row>
                            <FormLayout.Row className="d-flex flex-wrap">
                                <div className="w-50 p-2">
                                    <DateInput
                                        label="Start Date"
                                        name="startDate"
                                        value={values.startDate}
                                        onChange={handleChange}
                                    />
                                </div>
                                <div className="w-50 p-2">
                                    <DateInput
                                        label="End Date"
                                        name="endDate"
                                        value={values.endDate}
                                        onChange={handleChange}
                                    />
                                </div>
                            </FormLayout.Row>
                        </Modal.Body>
                        <Modal.Footer>
                            <button
                                type="button"
                                onClick={onHide}
                                className="btn btn-light btn-elevate px-4"
                                disabled={isUpdating}
                            >
                                Close
                            </button>
                            <button
                                type="submit"
                                className="btn btn-primary btn-elevate px-4 ml-4"
                                disabled={isUpdating}
                            >
                                Update
                            </button>
                        </Modal.Footer>
                    </Form>
                )}
            </Formik>
        </Modal>
    );
};

export default EditCampaignModal;
